import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import { SpawnPlayerPartyScript, DefeatAllUnitsOfAffiliation, HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

const tiledWorld = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/tileset.json"),
})

export default {
    "slug": "gluttony",
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "stage": {
        "image": require("./image.png"),
        "world": tiledWorld,
        "units": require("./units.json"),
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Opening:Music")},
                    SpawnPlayerPartyScript(),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "good",
                    })
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 1,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 2}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 2,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 3}),
                    {
                        "type": "Dialogue",
                        "deltastages": [
                            {
                                "mark": 500,
                                "unit": {"key": "archdevil", "position": {"x": 6, "y": 7}},
                            },
                            {
                                "mark": 530,
                                "unit": {"key": "archdevil", "position": {"x": 6, "y": 6}},
                            },
                            {
                                "mark": 560,
                                "unit": {"key": "archdevil", "position": {"x": 7, "y": 6}},
                            },
                            {
                                "mark": 760,
                                "audio": {"triggerKey": "Hell:Scream"},
                            },
                            {
                                "mark": 760,
                                "unit": {"key": "archdevil", "faceKey": "devilscream"},
                            },
                            {
                                "mark": 1260,
                                "unit": {"key": "archdevil", "faceKey": "devil"},
                            },
                        ]
                    },
                ]
            },
            {
                "encounterKey": 3,
                "type": "defeat-all-units-of-affiliation", "affiliation": "bad",
                "events": [
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/title/splash")},
                ]
            },
        ]
    },
}
